// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__4V77n","buttonSizeS":"button_buttonSizeS__KSUWg","buttonText":"button_buttonText__UTUiZ","outlined":"button_outlined__cnjWp"};